export function newLineToSpace(htmlString: string): string {
  // Replace newline characters with a single space
  const result = htmlString.replace(/\n/g, " ");
  return result;
}

export function isNullOrEmptyString(str: string | null | undefined): boolean {
  return str === undefined || str === null || str?.trim() === "";
}

export function getIndefiniteArticle(nextWord: string): string {
  if (!nextWord) return "a";
  const firstLetter = nextWord.trim()[0]?.toLowerCase() ?? "";
  return ["a", "e", "i", "o", "u"].includes(firstLetter) ? "an" : "a";
}
